import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import FileAttach from "../../../../../../images/BrowseFiles.svg";
import DownArrow from "../../../../../../images/DownArrow.svg";
import TotalStudents from "../../../../../../images/TotalMale.svg";
import ReadyToImport from "../../../../../../images/Present.svg";
import ContainsError from "../../../../../../images/Absent.svg";
import ExcelJS from "exceljs";
import Info from "../../../../../../images/Information.svg";

import Close from "../../../../../../images/Close.svg";
import ReactModal from "react-modal";

import { useLazyQuery, useMutation } from "@apollo/client";

import * as XLSX from "xlsx";
import Validate from "../../../../../../images/Validate.svg";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import useUrlParams from "../../../../../../customHooks/useUrlParams";

import {
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
} from "../../../../../../utils/Enum.types";
import { Title } from "../../../../../../stories/Title/Title";
import { CustomTooltip } from "../../../../../../styles/TooltipStyles";
import { Button } from "../../../../../../stories/Button/Button";
import {
  LoadingStyles,
  ViewPickedSubjectModalStyles,
} from "../../../../../../styles/ModalStyles";
import ExcelLoading from "../../../../../pages/ExcelLoading";
import MessageModal from "../../../../../../customComponents/MessageModal";

import { AtsSubsidiaryOrderField } from "../queries/types";
import { getDownloadUrl } from "../../../../../../utils/DownloadFile";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import { ImportJunctionsMutation } from "./queries/mutations";

import { AppContext } from "../../../../../../context/context";
import Navbar from "../../../../../common/layout/Navbar";
import useLabels from "../../../../../../customHooks/useLabels";
import { useNavigate } from "react-router-dom";
import { removeCompleteSpace } from "../../../../../../utils/UtilFunctions";
import {
  ExportJunctionTemplate,
  GetJunctions,
  ValidateJunctionForImport,
} from "./queries/queries";
import {
  ExportJunctionTemplateData,
  ExportJunctionTemplateVars,
  ImportJunctionDetails,
  ImportJunctionsVars,
  ValidateJunctionForImportResult,
  ValidateJunctionForImportVariables,
} from "./queries/types";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
  NavType: LicenseTypes;
}
interface Property {
  value: string;
  label: string;
  isSelected?: boolean;
}

const ImportJunctions = ({ setModalFlag, NavType, pageType }: Props) => {
  const [records, setRecords] = useState<any[]>([]);
  const { junctionLabel, subsidiaryLabel, subsidiarySiteLabel } = useLabels();

  const [stdConfig, setStdConfig] = useState(false);

  const [message, setMessage] = useState(emptyMessage);
  const { customer_id, company_id, sub_id, siteID } = useUrlParams();
  const [importModal, setImportModal] = useState(false);
  const [successCount, setSuccessCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);

  const { user_details } = useLoggedInUserDetails();
  const { state } = useContext(AppContext);

  const navigate = useNavigate();
  const [ValidateEachRow] = useLazyQuery<
    ValidateJunctionForImportResult,
    ValidateJunctionForImportVariables
  >(ValidateJunctionForImport);

  const [expanded, setExpanded] = useState(false);

  const [ImportJunction, { loading }] = useMutation<
    ImportJunctionDetails,
    ImportJunctionsVars
  >(ImportJunctionsMutation, {
    onError: (e) =>
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      }),
  });
  const [ExportJunction, { loading: AddItemLoading }] = useLazyQuery<
    ExportJunctionTemplateData,
    ExportJunctionTemplateVars
  >(ExportJunctionTemplate, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });
  const displayFileName = (): void => {
    const inputElement = document.getElementById("input") as HTMLInputElement;
    const fileName = inputElement.value;
    const fileLabel = document.getElementById("file-name") as HTMLSpanElement;
    fileLabel.innerHTML = fileName.split("\\").pop()!;
  };
  const handleExport = async () => {
    try {
      if (customer_id) {
        const { data, errors } = await ExportJunction({
          variables: {
            customerID: customer_id,
            atSiteLevel: siteID ? true : false,
          },
        });

        if (data && data.ExportJunctionTemplate) {
          const res = await getDownloadUrl(data.ExportJunctionTemplate, true);
          if (res) {
            setMessage({
              flag: true,
              message: "Downloading...",
              operation: Operation.CREATE,
            });
          }
        } else {
          setMessage({
            flag: true,
            message: "Failed downloading file",
            operation: Operation.NONE,
          });
        }

        if (errors && errors.length > 0) {
          setMessage({
            flag: true,
            message: errors[0].message,
            operation: Operation.NONE,
          });
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };
  const totalRecords = useMemo(() => {
    return records.filter((record) => !record.errors).length;
  }, [records]);
  const downloadExcelContainsError = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet("ErrorData");
    worksheet1.views = [{ state: "frozen", xSplit: 1, ySplit: 1 }];
    if (records.length === 0) {
      console.warn("No data available to create the Excel file.");
      return;
    }

    const errorColumns = ["errors"];
    const headers = Object.keys(records[0]).filter(
      (header) =>
        !["isChecked", "isValidated", "isValidatedAndError", "id"].includes(
          header
        )
    );

    errorColumns.forEach((col) => {
      if (!headers.includes(col)) {
        headers.push(col);
      }
    });
    worksheet1.columns = headers.map((header) => ({
      header,
      key: header,
      width: 20,
    }));

    const headerRow = worksheet1.getRow(1);
    headerRow.height = 25;
    headerRow.font = { name: "Arial", size: 12, bold: true };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFE0B2" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    records
      .filter((record) => record?.errors)
      .forEach((entry, rowIndex) => {
        const row = worksheet1.getRow(rowIndex + 2);
        headers.forEach((header, colIndex) => {
          const cell = row.getCell(colIndex + 1);
          cell.value = entry[header];
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });
      });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "StudentInfo.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };
  const handleAddSubsidiarySite = async () => {
    setSuccessCount(0);
    setErrorCount(0);
    setImportModal(true);

    for (const record of records.filter((record) => !record.errors)) {
      try {
        console.log(
          subsidiarySiteLabel,
          record[`${removeCompleteSpace(subsidiarySiteLabel)}`]
        );

        await ImportJunction({
          variables: {
            customerID: customer_id!,
            companyID: company_id!,
            subsidiaryID: sub_id ? sub_id : 0,
            user_details,
            input: {
              subsidiaryName: record[`${removeCompleteSpace(subsidiaryLabel)}`],
              siteName: record[`${removeCompleteSpace(subsidiarySiteLabel)}`],
              address: record.Address,
              place: record.Place,
              state: record.State,
              pin: record.Pin,
              priority: record.Priority,
              alias: record.Alias,
              jType: record.Type,
              arms: record.Arms,
              icon: record.Icon,
              country: record.Country,
              latitude: record.Latitude,
              longitude: record.Longitude,
              code: record.Code,
              junction: record[`${removeCompleteSpace(junctionLabel)}`],
              vendor: record.Vendor,
              poles: record.Poles,
            },
            siteID: siteID ? siteID : 0,
          },
          refetchQueries: [
            {
              query: GetJunctions,
              variables: {
                after: null,
                customerID: customer_id,
                companyID: company_id,
                empID: user_details.id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsSubsidiaryOrderField.NAME,
                },
                name: EMPTY_STRING,
                subsidiaryID: sub_id
                  ? sub_id
                  : state.subsidiaryId
                  ? state.subsidiaryId
                  : 0,
                siteID: siteID ? siteID : 0,
              },
            },
          ],
        }).then(({ data }) => {
          if (data) {
            setSuccessCount((prev) => prev + 1);
          }
        });
      } catch (error) {
        console.error(error);
        setErrorCount((prev) => prev + 1);
      }
    }
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      setModalFlag(false);
    }
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };
  const site_schema = {
    [`${removeCompleteSpace(subsidiaryLabel)}`]: {
      Headers: `${subsidiaryLabel}`,
      key: `${removeCompleteSpace(subsidiaryLabel)}`,
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    [`${removeCompleteSpace(subsidiarySiteLabel)}`]: {
      Headers: `${subsidiarySiteLabel}`,
      key: `${removeCompleteSpace(subsidiarySiteLabel)}`,
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    [`${removeCompleteSpace(junctionLabel)}`]: {
      Headers: `${junctionLabel}`,
      key: `${removeCompleteSpace(junctionLabel)}`,
      width: 50,
      required: true,
      use_in_sheet: true,
    },
    Vendor: {
      Headers: "Vendor",
      key: "vendor",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Code: {
      Headers: "Code",
      key: "code",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Address: {
      Headers: "Address",
      key: "address",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Place: {
      Headers: "Place",
      key: "place",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    State: {
      Headers: "State",
      key: "state",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Pin: {
      Headers: "PIN Code",
      key: "pin",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Priority: {
      Headers: "Priority",
      key: "priority",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Country: {
      Headers: "Country",
      key: "country",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Alias: {
      Headers: "Alias",
      key: "alias",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Type: {
      Headers: "Type",
      key: "jType",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Arms: {
      Headers: "Arms",
      key: "arms",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Poles: {
      Headers: "Poles",
      key: "poles",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Icon: {
      Headers: "Icon",
      key: "icon",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Latitude: {
      Headers: "Latitude",
      key: "latitude",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Longitude: {
      Headers: "Longitude",
      key: "longitude",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
  };

  const processExcel = (data: any) => {
    const workbook = XLSX.read(data, { type: "binary" });
    const firstSheet = workbook.SheetNames[0];
    const records = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet]);
    records.forEach((record: any) => {
      let errors: any = [];

      Object.keys(site_schema).forEach((key) => {
        // @ts-ignore
        let keySchema = site_schema[key];
        let keyValue = record[key];

        if (
          keySchema?.required &&
          (keyValue === null || keyValue === undefined)
        ) {
          let errorObj = {
            column: key,
            error: "Required",
          };
          errors.push(errorObj);
        }
      });

      if (errors.length > 0) {
        record.errors = errors;
      }
    });

    return records;
  };

  useEffect(() => {
    const input = document.getElementById("input") as HTMLInputElement;
    if (input) {
      input.addEventListener("change", () => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const res = processExcel(reader.result);
          setRecords(
            res.map((f: any, index: number) => {
              return {
                ...f,
                id: index + 1,
                isChecked: false,
                isValidated: false,
                isValidatedAndError: false,
              };
            })
          );
        };
        reader.readAsBinaryString(input.files![0]);
      });
    }
  });
  const handleButtonClick = async () => {
    try {
      await Promise.all(records.map((record) => handleClick(record.id)));
    } catch (error) {
      console.error(error);
    }
  };

  const handleClick = async (id: number) => {
    try {
      const filteredData = records.find((record) => record.id === id);

      if (filteredData) {
        const { data, errors } = await ValidateEachRow({
          variables: {
            customerID: customer_id!,

            companyID: company_id!,
            siteName:
              filteredData[`${removeCompleteSpace(subsidiarySiteLabel)}`],
            subsidiaryName:
              filteredData[`${removeCompleteSpace(subsidiaryLabel)}`],
            junctionName: filteredData[`${removeCompleteSpace(junctionLabel)}`],
          },
        });

        if (data) {
          const newData = records.map((record) => {
            if (id === record.id) {
              return {
                ...record,
                isChecked: !record?.isChecked,
                isValidated: !record.isValidated,
                isValidatedAndError: false,
              };
            }
            return record;
          });
          setRecords(newData);
          return Promise.resolve(data);
        }

        if (errors && errors.length > 0) {
          const newData = records.map((record) => {
            if (record.id === id) {
              record.errors = record.errors ? record.errors : [];
              record.errors.push(errors[0]?.message);
              return {
                ...record,
                isChecked: !record?.isChecked,
                isValidated: true,
                isValidatedAndError: true,
              };
            }
            return record;
          });
          setRecords(newData);
          return Promise.reject(errors[0]);
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message || "An error occurred",
        operation: Operation.NONE,
      });
      return Promise.reject(err);
    }
  };

  const schemaKeys = Object.keys(site_schema);

  return (
    <>
      {pageType === PageFor.GENERAL ? (
        <>
          <Navbar NavType={NavType} />
          <Title>Import {junctionLabel} Details</Title>
        </>
      ) : null}
      <div
        className={`import-excel-data${
          pageType === PageFor.GENERAL ? "" : "__modal"
        }`}
      >
        {" "}
        {pageType === PageFor.MODAL && (
          <div className="import-excel-data--title">
            <Title>Import {junctionLabel} Details</Title>
            <img src={Close} alt="" onClick={() => setModalFlag(false)} />
          </div>
        )}
        <div className="row g-0 import-excel-data__blocks">
          <div className="col-6">
            <div className="import-excel-data__file-upload">
              <div className="import-excel-data__file-upload--file-name">
                <span id="file-name"></span>
              </div>
              <div className="import-excel-data__file-upload--browse">
                <label htmlFor="input">
                  <img src={FileAttach} alt="/" /> Choose Excel File
                </label>
                <input
                  id="input"
                  type="file"
                  name="file"
                  onChange={() => displayFileName()}
                  className="import-excel-data__file-upload--input"
                />
              </div>
            </div>
          </div>

          <div className="col import-excel-data__blocks--cards">
            <b>
              <img src={TotalStudents} alt="/" />
              Total {junctionLabel}
            </b>
            <span className="import-excel-data__blocks--cards--total-students">
              {records.length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
            // onClick={() => setExpanded(!expanded)}
          >
            <b>
              <img src={ReadyToImport} alt="/" />
              Ready to Import
            </b>
            <span className="import-excel-data__blocks--cards--ready-to-import">
              {records.filter((record) => !record.errors).length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
            onClick={() => setExpanded(!expanded)}
          >
            <b>
              <img src={ContainsError} alt="/" />
              Contains Error
            </b>
            <span className="import-excel-data__blocks--cards--contains-error">
              {records.filter((record) => record?.errors).length}
            </span>
          </div>
        </div>
        <div
          className={`import-excel-data__datablock${
            pageType === PageFor.MODAL ? "" : "--general"
          }`}
        >
          {records.length > 0 ? (
            <>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded(!expanded)}
              >
                <div className="import-excel-data__datablock--records-count">
                  <span>
                    {records.filter((record) => !record.errors).length}
                  </span>
                  <b> Records Found to Import</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              <div className="import-excel-data__datablock--tableblock">
                <TableContainer className="import-excel-data__datablock--table">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell id="td-center">
                          {TableHeaders.SLNO}
                        </TableCell>
                        {schemaKeys
                          .filter((key) =>
                            records.some((record) => key in record)
                          )
                          .map((key, index) => (
                            <TableCell key={index}>{key}</TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {records
                        .filter((record) => !record?.errors)
                        .map((record, index) => (
                          <TableRow key={index}>
                            <TableCell id="td-center">{index + 1}</TableCell>
                            {schemaKeys
                              .filter((key) => key in record)
                              .map((key, colIndex) => (
                                <Fragment key={colIndex}>
                                  <TableCell key={colIndex}>
                                    {record[key]}
                                  </TableCell>
                                </Fragment>
                              ))}
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded(!expanded)}
              >
                <div className="import-excel-data__datablock--errors-count">
                  <span>{records.filter((d) => d?.errors).length}</span>
                  <b>Records Which Contains error(s)</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              {expanded && (
                <div className="import-excel-data__datablock--tableblock">
                  <TableContainer className="import-excel-data__datablock--table">
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell id="td-center">
                            {TableHeaders.SLNO}
                          </TableCell>
                          {schemaKeys
                            .filter((key) =>
                              records.some((record) => key in record)
                            )
                            .map((key, index) => (
                              <TableCell key={index}>{key}</TableCell>
                            ))}
                          <TableCell id="td-center">Error Details</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {records
                          .filter((record) => record?.errors)
                          .map((record, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell id="td-center">
                                  {index + 1}
                                </TableCell>
                                {schemaKeys
                                  .filter((key) => key in record)
                                  .map((key, colIndex) => (
                                    <Fragment key={colIndex}>
                                      <TableCell>{record[key]}</TableCell>
                                    </Fragment>
                                  ))}

                                <TableCell className="import-excel-data__datablock--error">
                                  <CustomTooltip
                                    title={
                                      <ul>
                                        {record?.errors
                                          ? record?.errors?.map(
                                              (error: any, index: number) => {
                                                return (
                                                  <li key={index}>
                                                    {index + 1})&nbsp;
                                                    {typeof error === "string"
                                                      ? error
                                                      : "Error message = " +
                                                        error.error +
                                                        ", column = " +
                                                        error.column}
                                                  </li>
                                                );
                                              }
                                            )
                                          : null}
                                      </ul>
                                    }
                                    arrow
                                    placement="bottom-start"
                                  >
                                    <div className="import-excel-data__datablock--tableblock--error-message">
                                      <span>Errors</span>
                                      <img src={Info} alt="/" />
                                    </div>
                                  </CustomTooltip>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </>
          ) : null}
        </div>
        <div className="row g-0">
          <div className="col">
            <Button
              onClick={() => {
                handleAddSubsidiarySite();
              }}
              disabled={!records.length ? true : false}
              mode="excel"
            >
              Import
            </Button>
            <Button onClick={handleButtonClick}>
              <img src={Validate} alt="" />
              Validate
            </Button>
            <Button onClick={downloadExcelContainsError} mode="excel">
              Export error Data
            </Button>
            <Button
              mode={pageType === PageFor.GENERAL ? "back" : "cancel"}
              onClick={() => {
                if (pageType === PageFor.MODAL) {
                  setModalFlag(false);
                } else {
                  navigate(-1);
                }
              }}
            />
          </div>
          <div className="col-3 import-excel-data__button">
            <Button mode="excel" onClick={handleExport}>
              Generate Template XLS File
            </Button>
          </div>
        </div>
      </div>

      <ReactModal
        shouldCloseOnOverlayClick={true}
        isOpen={importModal}
        style={LoadingStyles}
        ariaHideApp={false}
        onRequestClose={() => setImportModal(!importModal)}
      >
        <ExcelLoading
          total={totalRecords}
          success={successCount}
          errors={errorCount}
          loading={loading}
          setModalFlag={setImportModal}
        />
      </ReactModal>
      {/* <LoadingModal flag={AddItemLoading} /> */}
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
      <ReactModal
        shouldCloseOnOverlayClick={true}
        isOpen={stdConfig}
        style={ViewPickedSubjectModalStyles}
        ariaHideApp={false}
      >
        <div className="import-excel-data__receipts">
          <div className="import-excel-data__receipts--title">
            <Title>Choose Properties</Title>
            <img
              src={Close}
              alt="/"
              className="modal-close-icon"
              onClick={() => setStdConfig(!stdConfig)}
            />
          </div>

          {/* <Button mode="excel" onClick={handleExport}>
              Download To Excel
            </Button> */}

          <Button mode="cancel" onClick={() => setStdConfig(!stdConfig)} />
        </div>
      </ReactModal>
    </>
  );
};

export default ImportJunctions;
